import type { LeaderboardPlayer, LeaderboardTeam } from "../../types/leaderboard";
import type { PlayerRole } from "./roles";
import { normalizeRole } from "./roles";

export interface IndividualPlayerEntry extends LeaderboardPlayer {
  position: number;
  teamId: string;
  teamName: string;
  teamFullName: string;
  teamLogoUrl: string;
}

export interface IndividualLeaderboardFilters {
  teamId?: string | null;
  role?: PlayerRole | null;
}

export function normalizeLeaderboardTeams(teams: LeaderboardTeam[]): LeaderboardTeam[] {
  return teams.map((team) => ({
    ...team,
    players: team.players.map((player) => ({
      ...player,
      role: normalizeRole(player.role),
    })),
  }));
}

export function buildIndividualLeaderboard(
  teams: LeaderboardTeam[],
  filters: IndividualLeaderboardFilters = {},
): IndividualPlayerEntry[] {
  const teamId = filters.teamId ?? null;
  const role = filters.role ?? null;

  const filteredTeams = teamId ? teams.filter((team) => team.teamId === teamId) : teams;

  const players = filteredTeams.flatMap((team) =>
    team.players
      .filter((player) => !role || player.role === role)
      .map((player) => ({
        ...player,
        teamId: team.teamId,
        teamName: team.teamName,
        teamFullName: team.fullName,
        teamLogoUrl: team.logoUrl,
        position: 0,
      })),
  );

  return players
    .sort((a, b) => b.score - a.score)
    .map((player, index) => ({
      ...player,
      position: index + 1,
    }));
}
